'use client';
import { useClientTranslation } from '@/hook/translate';
import clsx from 'clsx';
import { Image } from '@nextui-org/react';
import { useState } from 'react';
import BookList from './BookList';
import { listenBrief } from '@/types/audioResData';
import { MindfulAudioImg } from '@/config/img/mindfulAudio';

interface IProps {
  bookList: listenBrief.TReaderBook[];
}

export default function ReaderContent(props: IProps) {
  const [show, setShow] = useState(true);
  const { t } = useClientTranslation();
  return (
    <div className='bg-[rgba(255,255,255,0.08)] mt-10 rounded-[40px] py-[50px]'>
      <h2 className='text-34-46 font-extrabold flex items-center'>
        <span className=" font-extrabold text-40-55 pr-[10px]">{t('readerEnjoyedSummary', 'mindfulAudio')}</span>
        <Image className={clsx(show ? 'block' : 'hidden', 'cursor-pointer')} src={MindfulAudioImg.ReaderDown} width={30} height={30} alt='down' onClick={() => setShow(false)} />
        <Image className={clsx(!show ? 'block' : 'hidden', 'cursor-pointer')} src={MindfulAudioImg.Triangle} width={30} height={30} alt='down' onClick={() => setShow(true)} />
      </h2>
      <div className={ clsx('book-list pt-[30px]', show ? 'block' : 'hidden') }>
       {
        props?.bookList?.length > 0 ?
        <BookList bookList={ props.bookList } length={ 6 } />
          : null
       }
      </div>
    </div>
  );
}
